const API_BASE_URL: string = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_API_BASE_URL ?? 'none-api-base-url-in-dotenv'
  : `${window.location.protocol}//${window.location.host}:23337`;

export default API_BASE_URL;